import { requestApi } from './Api';

export const getUserPreferences = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/preferences/get',
    params
  });

export const getUserTablePreferences = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/preferences/table_preferences',
    params
  });

export const updateUserPreferences = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/preferences/upsert',
    params
  });

export const getPracticePreferences = async (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/practice/preferences/get',
    params
  });
};

export const upsertPracticePreferences = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/preferences/upsert',
    params
  });
